import { BrandliveEvent } from '@/types/projects.types';
import {
  CourseRequirementType,
  PulseCheckSettings,
  ICreateCourseRequirement,
  ICourseRequirement,
} from '@/types/courses';

export const getBannerImage = (event: BrandliveEvent | null | undefined) => {
  if (!event) return undefined;

  if (event.event_image) {
    return event.event_image;
  }

  const [firstSession] = event.sessions;

  return firstSession.pre_broadcast_thumbnail ?? firstSession.post_broadcast_thumbnail ?? firstSession.image;
};

export const defaultSettings = (type: CourseRequirementType) => {
  if (type === CourseRequirementType.pulse_check) {
    return {
      pulseCheckDisplayDuration: 5,
      pulseCheckButtonText: {
        base: 'Yes',
        changed: '',
      },
      pulseCheckText: {
        base: 'Are you still watching?',
        changed: '',
      },
      audibleNotification: false,
    } as PulseCheckSettings;
  }

  return {};
};

export const defaultNewRequirement: ICreateCourseRequirement = {
  type: CourseRequirementType.watched_minute,
  session_id: 0,
  unit_type: 'discrete',
  points: 0,
  settings: {},
  required_amount: 0,
  // Unused below, will be handled in the API but needed for typescript
  course_id: 0,
  channel: 0,
  created_by: 0,
};

export const getRequirementMapBySession = (
  requirements: (ICourseRequirement | ICreateCourseRequirement)[] | undefined
) => {
  return (
    requirements?.reduce<Record<number, string[]>>((acc, req) => {
      if (acc[req.session_id]) {
        acc[req.session_id].push(req.type);
      } else {
        acc[req.session_id] = [req.type];
      }
      return acc;
    }, {}) ?? {}
  );
};
